import React, { useState, useEffect } from "react";
import { Table, Transfer, Form, Input, Select, Button } from "antd";
import { difference } from "lodash";
import { owntoast, renderOptions } from "../../utils";
import { EditableCell, EditableRow } from "../TableEditAble";
import dayjs from "dayjs";
import Formatter from "../../utils/data_formatter";
import UsefulFunctions from "../../utils/UsefulFunctions";
const components = {
  body: {
    row: EditableRow,
    cell: EditableCell,
  },
};
const CountingEdit = (props) => {
  const [form] = Form.useForm();
  const [countData, setCountData] = useState([]);
  const [data, setData] = useState([]);
  const [inventory, setInvetory] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeStore = (e) => {
    setData([]);
    setInvetory([]);
    setCountData([]);
    form.setFieldsValue({ counting: null });
    props.request({ url: `/count/popup/${e}`, method: "POST" }).then((res) => {
      if (res.success) {
        setCountData(res.data);
      }
      getInventory(e);
    });
  };

  const getInventory = (storeid, isrefresh) => {
    let body = {
      sdate: dayjs().format("YYYY-MM-DD"),
      edate: dayjs().format("YYYY-MM-DD"),
      storeid: storeid,
      pagenumber: 0,
      count: 999999,
    };
    setLoading(true);
    props
      .request({ url: `/report/inventory`, body: body, method: "POST" })
      .then((res) => {
        setLoading(false);
        if (res.success) {
          if (res.data.reportList) {
            setInvetory(res.data.reportList);
          }
        }
      });
  };

  const onChangeCount = (values) => {
    let res = countData.find((x) => x.id === values.counting);
    if (res) {
      if (res.details) {
        setNewData(res.details);
      }
    }
  };

  useEffect(() => {
    if (data) {
      if (inventory && inventory.length) form.submit();
    }
  }, [inventory]);

  const setNewData = (details) => {
    setData(() => {
      details.map((item, i) => {
        if (inventory) {
          let finded = inventory.find((x) => x.productid === item.productid);
          if (finded) {
            item.inv = finded.qty;
            item.diff = item.inv - item.qty;
            item.cedit = item.diff * -1;
            item.diffamt = item.diff * item.saleprice;
          } else {
            item.inv = 0;
            item.diff = 0 - item.qty;
            item.cedit = 0;
            item.diffamt = item.diff * item.saleprice;
          }
        }
      });
      return details;
    });
  };

  const handleSave = (row) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };

  const handleEdit = async () => {
    await form.validateFields();
    let values = form.getFieldsValue();
    let tmp = [];
    data.map((item, i) => {
      if (item.cedit > 0 || item.cedit < 0) {
        tmp.push({
          storeid: values.storeid,
          productid: item.productid,
          barcode: item.code,
          name: item.productname,
          qty: item.cedit,
        });
      }
    });

    setLoading(true);
    props
      .request({ url: `/count/edit`, body: tmp, method: "POST" })
      .then((res) => {
        setLoading(false);
        if (res.success) {
          owntoast(res.message, "success");
          let values = form.getFieldValue();
          getInventory(values.storeid, true);
        } else {
          owntoast(res.message, "error");
        }
      });
  };

  const columns = [
    {
      title: "Барааны нэр",
      dataIndex: "productname",
      key: "productname",
      align: "right",
    },
    {
      title: "Код",
      dataIndex: "code",
      key: "code",
      align: "right",
    },
    {
      title: "Авах үнэ",
      dataIndex: "cost",
      key: "cost",
      align: "right",
      render: (value, row) => (
        <Formatter value={value} format="price" row={row} />
      ),
    },
    {
      title: "Зарах үнэ",
      dataIndex: "price",
      key: "price",
      align: "right",
      render: (value, row) => (
        <Formatter value={value} format="price" row={row} />
      ),
    },
    {
      title: "Хэмжээ",
      dataIndex: "size",
      key: "size",
      align: "right",
    },
    {
      title: "Нөөц",
      dataIndex: "inv",
      key: "inv",
      align: "right",
    },
    {
      title: "Тоолсон тоо",
      dataIndex: "qty",
      key: "qty",
      align: "right",
    },

    {
      title: "Зөрүү тоо",
      dataIndex: "diff",
      key: "diff",
      align: "right",
      isSum: true,
    },
    {
      title: "Зөрүү дүн",
      dataIndex: "diffamt",
      key: "diffamt",
      align: "right",
      isSum: true,
    },
    {
      title: "Засалт",
      dataIndex: "cedit",
      key: "cedit",
      align: "center",
      editable: true,
      width: 100,
      onCell: (record) => ({
        record,
        editable: true,
        dataIndex: "cedit",
        title: "Засалт",
        handleSave,
      }),
    },
  ];

  return (
    <div className="mb-5">
      <Form onFinish={onChangeCount} form={form}>
        <div className="flex flex-wrap gap-2">
          <Form.Item
            name="storeid"
            className="w-40"
            rules={[{ message: `Дэлгүүр сонгоно уу.`, required: true }]}
          >
            <Select
              allowClear
              placeholder="Дэлгүүр сонгох"
              showSearch
              loading={loading}
              onChange={onChangeStore}
            >
              {renderOptions(props.resstore, "name", "id")}
            </Select>
          </Form.Item>
          <Form.Item
            name="counting"
            className="w-40"
            rules={[{ message: `Тооллого сонгоно уу.`, required: true }]}
          >
            <Select
              allowClear
              loading={loading}
              placeholder="Тооллого сонгох"
              showSearch
            >
              {renderOptions(countData, "name", "id")}
            </Select>
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Хайх
          </Button>
        </div>
      </Form>
      <Table
        loading={loading}
        scroll={{ y: "25rem" }}
        columns={[
          {
            title: "Барааны нэр",
            dataIndex: "productname",
            key: "productname",
            align: "right",
          },
          {
            title: "Авах үнэ",
            dataIndex: "cost",
            key: "cost",
            align: "right",
            render: (value, row) => (
              <Formatter value={value} format="price" row={row} />
            ),
          },
          {
            title: "Зарах үнэ",
            dataIndex: "price",
            key: "price",
            align: "right",
            render: (value, row) => (
              <Formatter value={value} format="price" row={row} />
            ),
          },
          {
            title: "Хэмжээ",
            dataIndex: "size",
            key: "size",
            align: "right",
          },
          {
            title: "Нөөц",
            dataIndex: "inv",
            key: "inv",
            align: "right",
          },
          {
            title: "Тоолсон тоо",
            dataIndex: "qty",
            key: "qty",
            align: "right",
          },

          {
            title: "Зөрүү тоо",
            dataIndex: "diff",
            key: "diff",
            align: "right",
            render: (value, row) => (
              <Formatter value={value} format="price" row={row} />
            ),
            isSum: true,
          },
          {
            title: "Зөрүү дүн",
            dataIndex: "diffamt",
            key: "diffamt",
            align: "right",
            render: (value, row) => (
              <Formatter value={value} format="price" row={row} />
            ),
            isSum: true,
          },
          {
            title: "Засалт",
            dataIndex: "cedit",
            key: "cedit",
            align: "center",
            editable: true,
            // width: 100,
            onCell: (record) => ({
              record,
              editable: true,
              dataIndex: "cedit",
              title: "Засалт",
              handleSave,
            }),
          },
        ]}
        summary={(pageData) => (
          <Table.Summary fixed style={{ background: "#fafafa" }}>
            <Table.Summary.Row>
              {UsefulFunctions.renderSummary({
                data: pageData,
                columns,
                isPagination: false,
              })}
            </Table.Summary.Row>
          </Table.Summary>
        )}
        components={components}
        dataSource={data}
        size="small"
        rowClassName={() => "editable-row"}
        pagination={false}
      />
      <div className="w-full  mt-5">
        <Button
          className="float-right"
          type="primary"
          onClick={handleEdit}
          loading={loading}
        >
          Засалт хийх
        </Button>
      </div>
    </div>
  );
};

export default CountingEdit;
